import { FormHandles } from '@unform/core';
import { Form } from '@unform/web';
import { Input } from 'components/Shared';
import { useValidation } from 'hooks';
import React, { useCallback, useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import type { AppDispatch, RootState } from 'store';
import { LoginActions as MainActions } from 'store/ducks/auth';
import ReCAPTCHA from 'react-google-recaptcha';
import * as Yup from 'yup';
import * as S from './styles';
import { notify } from 'services';

const RECAPTCHA_KEY = '6LcCQuQmAAAAAJaa-uGEygXAanLjWHkRLv_HfPRs'
const RECAPTCHA_ENABLED = process.env.REACT_APP_RECAPTCHA_ENABLED !== 'false'

export const LoginForm: React.FC = () => {
  const dispatch: AppDispatch = useDispatch();
  const formRef = useRef<FormHandles>(null);
  const { handleFormErrors, handleApiErrors } = useValidation();
  const [human, setHuman] = useState<string | null>(null);

  const { loading, validationErrors } = useSelector(
    (state: RootState) => state.login
  );

  const onRecaptcha = useCallback((key: string | null) => setHuman(key), []);

  const onSubmit = useCallback(
    async (data: any): Promise<void> => {
      try {
        formRef.current?.setErrors({});

        const schema = Yup.object().shape({
          email: Yup.string()
            .email('E-mail inválido')
            .required('E-mail obrigatório'),
          password: Yup.string().required('Senha obrigatória'),
        });

        const validData = await schema.validate(data, {
          abortEarly: false,
        });

        if (RECAPTCHA_ENABLED && !human) {
          return notify(
            'error',
            'Se você é um humano resolva o reCAPTCHA para prosseguir.'
          );
        }
        dispatch(
          MainActions.request({
            ...validData,
            ...(RECAPTCHA_ENABLED ? { humanKey: human } : {}),
          })
        );
      } catch (error) {
        handleFormErrors(error, formRef);
      }
    },
    [dispatch, handleFormErrors, human]
  );

  useEffect(() => {
    handleApiErrors(validationErrors, formRef);
  }, [handleApiErrors, validationErrors]);

  useEffect(() => {
    if (process.env.NODE_ENV === 'development') {
      //formRef.current?.setFieldValue('email', 'nando@gerasinergia.com.br');
      //formRef.current?.setFieldValue('password', 'Ew3dmisw');
    }
  });

  useEffect(() => {
    return () => {
      dispatch(MainActions.reset());
    };
  }, [dispatch]);

  return (
    <S.Container>
      <Form ref={formRef} onSubmit={onSubmit}>
        <Input name="email" label="E-mail" />
        <Input name="password" label="Senha" type="password" />
        <S.FormActions >
          {RECAPTCHA_ENABLED && (
            <ReCAPTCHA sitekey={RECAPTCHA_KEY} onChange={onRecaptcha} />
          )}
          <S.ButtonWrapper>
            <S.ForgotMyPwsLink to="/esqueci-minha-senha">
              Esqueceu sua senha?
            </S.ForgotMyPwsLink>
            <S.Button type="submit">
              {loading ? <S.ActivityIndicator /> : 'Entrar'}
            </S.Button>
          </S.ButtonWrapper>
        </S.FormActions>
      </Form>
    </S.Container>
  );
};
